/**
 * Converts a date string to ISO-like format without timezone: YYYY-MM-DD HH:MM:SS.mmm
 * Removes timezone abbreviations (PDT, PST, EST, etc.) from the input string
 * @param dateString - The date string to convert
 * @returns Formatted date string in ISO-like format
 */
export function convertToISOFormat(dateString: string): string {
  // Remove timezone abbreviation (PDT, PST, EST, etc.) from the end
  const cleanedDateString = dateString.replace(/\s[A-Z]{3,4}$/, '');

  // Parse the date string
  const date = new Date(cleanedDateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date format');
  }

  // Format to ISO-like format without timezone: YYYY-MM-DD HH:MM:SS.mmm
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

/**
 * Formats a Date object with the user's timezone and converts to ISO format
 * Gets the user's timezone automatically and returns formatted date for SQL Server
 * @param date - The Date object to format
 * @returns Formatted date string in ISO-like format
 */
export const formatDateWithTimezone = (date: Date): string => {
  // Get user's timezone
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //console.log('@@ - userTimezone => ', userTimezone)

  // Create a new date in the user's timezone
  const userDate = new Date(date.toLocaleString('en-US', {
    timeZone: userTimezone
  }));
  //console.log('@@ - userDate => ', userDate)
  //console.log('@@ - userDate.toLocaleString() => ', userDate.toLocaleString())

  // Return ISO string for SQL Server
  return convertToISOFormat(userDate.toISOString()); // Returns: "2023-12-25T14:30:45.000Z"
};
